import React from 'react';
import {Image, Button} from 'antd-mobile';
import {goCS, toPriceStr} from '@/utils';
import {useLogin, useUserInfo, useBalance} from '@/utils/state-hooks';
import {ReactComponent as LeftArrow} from '@/common-pages/agent/assets/left-arrow.svg';

interface AgentNavBarProps {
  onBack?: () => void;
}

const AgentNavBar: React.FC<AgentNavBarProps> = ({onBack}) => {
  // 使用现有的 hooks 获取状态
  const login = useLogin();
  const user = useUserInfo();
  const amount = useBalance();

  // 从用户信息中提取用户名和头像
  const userName = user?.userName || user?.userPhone || '';
  const userAvatar = user?.userAvatar || '';

  return (
    <div className="bg-white shadow-[0px_2px_4px_0px_rgba(204,206,228,0.5)] h-[2.75rem] px-3 py-[0.625rem] flex items-center justify-between relative z-10">
      {/* 左侧：返回按钮 + 用户信息 */}
      <div className="flex items-center gap-2">
        {/* 返回按钮 */}
        {onBack && (
          <Button
            onClick={onBack}
            className="w-6 h-6 p-0 border-0 bg-transparent cursor-pointer flex items-center justify-center">
            <LeftArrow className="w-6 h-6" />
          </Button>
        )}

        {/* 用户头像 */}
        <div className="w-8 h-8 rounded-full overflow-hidden">
          <Image
            src={
              userAvatar
                ? userAvatar
                : require('@components/assets/icons/default-header.webp')
            }
            className="w-full h-full object-cover"
            fallback={require('@components/assets/icons/default-header.webp')}
          />
        </div>

        {/* 用户信息 */}
        <div className="flex flex-col">
          <span className="text-xs text-t2 font-medium">
            {login ? userName : 'Guest'}
          </span>
          <span className="text-sm text-t1 font-bold font-din">
            {login ? toPriceStr(amount, {suffixUnit: 'K'}) : '-'}
          </span>
        </div>
      </div>

      {/* 右侧：客服图标 */}
      <Button
        onClick={goCS}
        className="w-6 h-6 p-0 border-0 bg-transparent cursor-pointer flex items-center justify-center">
        <Image
          src={require('@components/assets/icons/headphone.webp')}
          className="w-6 h-6"
        />
      </Button>
    </div>
  );
};

export default AgentNavBar;
